import { Injectable } from '@angular/core';
import { Globals } from './global';
// import * as $ from 'jquery';
import $ from 'jquery';

import moment from 'moment';
import { Features } from '../models/features.enum';
import { PermissionType } from '../models/permission.enum';
@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(private globals: Globals) { }

  //Method to get default meeting date
  getDefaultMeetingDate() {
    var curSysDate = new Date();
    var curDateAsUtc = curSysDate.getTime() + (curSysDate.getTimezoneOffset() * 60000);//current utc date with time
    var curDateAsVtz = new Date(curDateAsUtc + (3600000 * (this.globals.vTimeZoneIntOffset)));//convert utc to corresponding timezone
    var twoDigitDate = curDateAsVtz.getDate() + "";
    if (twoDigitDate.length == 1) {
      twoDigitDate = "0" + twoDigitDate;
    }
    var month = new Array();
    month[0] = "Jan";
    month[1] = "Feb";
    month[2] = "Mar";
    month[3] = "Apr";
    month[4] = "May";
    month[5] = "Jun";
    month[6] = "Jul";
    month[7] = "Aug";
    month[8] = "Sep";
    month[9] = "Oct";
    month[10] = "Nov";
    month[11] = "Dec";
    var monthInWord = month[curDateAsVtz.getMonth()];
    var newMeetDate = monthInWord + " " + twoDigitDate + ", " + curDateAsVtz.getFullYear();
    return newMeetDate;
  }
  getCurrentTimeBasedOnVisiterTimezone(){
    var time= new Date();
			var currentTime=time.getHours()+":"+time.getMinutes()+":"+time.getSeconds();
			   var curSysDate=new Date();
			   var meetUtc = curSysDate.getTime() + (curSysDate.getTimezoneOffset() * 60000);//current utc date with time
			   var fullDate = new Date(meetUtc + (3600000*(this.globals.vTimeZoneIntOffset)));//convert utc to corresponding timezone
			   var hour=this.addZero(fullDate.getHours());
			   var minutes=this.addZero(fullDate.getMinutes());
			   var seconds=this.addZero(fullDate.getSeconds());
			   var currentTime=hour+":"+minutes+":"+seconds;
         return currentTime
  }

  addZero(i:any) {
    if (i < 10) {
        i = "0" + i;
    }
    return i;
}

getDefaultInstantTime() {
  var reqTime = "";
  var curSysDate = new Date();
  var curDateAsUtc = curSysDate.getTime() + (curSysDate.getTimezoneOffset() * 60000);//current utc date with time
  var curDateAsVtz = new Date(curDateAsUtc + (3600000 * (this.globals.vTimeZoneIntOffset)));//convert utc to corresponding timezone
  var curHr = curDateAsVtz.getHours();
  var curMins = curDateAsVtz.getMinutes();
  
  if (curMins == 60) {
    reqTime = "" + (curHr + 1);
    if (reqTime.toString().length == 1) {
      reqTime = "0" + reqTime;
    }
    reqTime += ':' + "00";
  } else {
    var temphours = "";
    if (curHr.toString().length == 1) {
      temphours = "0" + curHr;
    } else {
      temphours = "" + curHr;
    }
    reqTime = temphours + ':' + curMins;
  }
  
  return reqTime;
}


  //Method to get default meeting time
  getDefaultMeetingTime() {
    var reqTime = "";
    var curSysDate = new Date();
    var curDateAsUtc = curSysDate.getTime() + (curSysDate.getTimezoneOffset() * 60000);//current utc date with time
    var curDateAsVtz = new Date(curDateAsUtc + (3600000 * (this.globals.vTimeZoneIntOffset)));//convert utc to corresponding timezone
    var curHr = curDateAsVtz.getHours();
    var curMins = curDateAsVtz.getMinutes();
    curMins = this.getRoundedTime(curMins);
    if (curMins == 60) {
      reqTime = "" + (curHr + 1);
      if (reqTime.toString().length == 1) {
        reqTime = "0" + reqTime;
      }
      reqTime += ':' + "00";
    } else {
      var temphours = "";
      if (curHr.toString().length == 1) {
        temphours = "0" + curHr;
      } else {
        temphours = "" + curHr;
      }
      reqTime = temphours + ':' + curMins;
    }
    
    return reqTime;
  }
  //Method to convert minutes to rounded minutes
  getRoundedTime(curMints: number) {
    var roundedMints = 0;
    if (curMints <= 15)
      roundedMints = 15;
    else if (curMints > 15 && curMints <= 30)
      roundedMints = 30;
    else if (curMints > 30 && curMints <= 45)
      roundedMints = 45;
    else
      roundedMints = 60;
    return roundedMints
  }
  //Method to check null
  nvl(value: any) {
    if (value == null || value == undefined || value == "null" || value == "undefined") {
      value = "";
    }
    return value;
  }
  /*Method to get the current offset of the node*/
  getCharacterOffsetWithin(range: any, node: Node) {
    var treeWalker = document.createTreeWalker(
      node,
      NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var nodeRange = document.createRange();
        nodeRange.selectNode(node);
        return nodeRange.compareBoundaryPoints(Range.END_TO_END, range) < 1 ?
          NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    }, 
      // false
    );
    var charCount = 0;
    while (treeWalker.nextNode()) {
      charCount += (<any>treeWalker.currentNode).length;
    }
    if (range.startContainer.nodeType == 3) {
      charCount += range.startOffset;
    }
    return charCount;
  }
//Method to select uneditable(contenteditable -false) text
selectUneditableText(event: any, element: any) {
  var range, selection;
  if (window.getSelection) {
    selection = window.getSelection();
    range = document.createRange();
    range.selectNode(element)
    selection?.removeAllRanges();
    selection?.addRange(range);
  } else {
    let documentBody = <any>document.body;
    range = documentBody.createTextRange();
    range.moveToElementText(element);
    range.select();
  }
  var evt = (event) ? event : event;
  if (evt.stopPropagation) evt.stopPropagation();
  if (evt.cancelBubble != null) evt.cancelBubble = true;
  return false;
}
//Method to get the text node
getTextNodesIn(node: any) {
  var textNodes: any = [];
  if (node.nodeType == 3) {
    textNodes.push(node);
  } else {
    var children = node.childNodes;
    for (var i = 0, len = children.length; i < len; ++i) {
      textNodes.push.apply(textNodes, this.getTextNodesIn(children[i]));
    }
  }
  return textNodes;
}

//Method to select and replace the selected text
selectAndHighlightRange(el: any, start: any, end: any, replacementStr: any) {
  if (document.createRange && window.getSelection) {
    var range = document.createRange();
    range.selectNodeContents(el);
    var textNodes = this.getTextNodesIn(el);
    var foundStart = false;
    var charCount = 0, endCharCount;
    for (var i = 0, textNode; textNode = textNodes[i++];) {
      endCharCount = charCount + textNode.length;
      if (!foundStart && start >= charCount && (start < endCharCount || (start == endCharCount && i <= textNodes.length))) {
        range.setStart(textNode, start - charCount);
        foundStart = true;
      }
      if (foundStart && end <= endCharCount) {
        range.setEnd(textNode, end - charCount);
        break;
      }
      charCount = endCharCount;
    }
    range.deleteContents();
    if (replacementStr != null && replacementStr != "" && replacementStr != undefined && replacementStr != "undefined") {
      var replacement = document.createTextNode(replacementStr);
      range.insertNode(replacement);
      range.setStartAfter(replacement);
    }
    var sel = window.getSelection();
    sel?.removeAllRanges();
    sel?.addRange(range);
  } else if ((<any>document).selection && (<any>document.body).createTextRange) {
    let documentBody = <any>document.body;
    var textRange = documentBody.createTextRange();
    textRange.moveToElementText(el);
    textRange.collapse(true);
    textRange.moveEnd("character", end);
    textRange.moveStart("character", start);
    textRange.select();
  }
}

//Method to replace shortcut 
replaceShortcut(additionalJson: any, obj: HTMLElement, replaceTxt: any) {
  if (additionalJson.start != null && additionalJson.start != "" && additionalJson.start != undefined && additionalJson.start != "undefined") {
    this.selectAndHighlightRange(obj, additionalJson.start, additionalJson.end, null);
  } else if (replaceTxt != null && replaceTxt != "" && replaceTxt != undefined && replaceTxt != "undefined") {
     var actualHtml = obj.innerHTML;
     obj.innerHTML=(actualHtml.replace(replaceTxt, ""));
  }

}
//Method to set cursor position at the end of the element
placeCaretAtEnd(el:HTMLElement) {
	if($(el).length>0){
    el.focus();
    if (typeof window.getSelection != "undefined" && typeof document.createRange != "undefined") {
      var range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(false);
      var sel = window.getSelection();
      sel?.removeAllRanges();
      sel?.addRange(range);
    }else if (typeof (<any>document.body).createTextRange != "undefined") {
      var textRange = (<any>document.body).createTextRange();
      textRange.moveToElementText(el);
      textRange.collapse(false);
      textRange.select();
    }
  }else{
    // var pos:any = 0;
    // pos = eval(pos + ($(window).height() + $(window).scrollTop()));
    // $('#scrollAgora').stop(true, false).animate({
    //   scrollHeight: pos
    // }, 1000);
  }
}


// collectionHas(a:any, b:any) { //helper function (see below)
//   for(var i = 0, len = a.length; i < len; i ++) {
//       if(a[i] == b) return true;
//   }
//   return false;
// }
// //method used to find the parent by selector
// findParentBySelector(elm:any, selector:any) {
//   var all = document.querySelectorAll(selector);
//   var cur = elm.parentNode;
//   while(cur && !this.collectionHas(all, cur)) { //keep going up until you find a match
//       cur = cur.parentNode; //go up
//   }
//   return cur; //will return null if not found
// }


//Method to remove last val
removeLastString(str: any, lastStr: any) {
  if (str != null && str != "" && str != undefined && str != "null") {
    if (str.lastIndexOf(lastStr) != -1) {
      var len = str.lastIndexOf(lastStr);
      str = str.substring(0, len)
    }
    return str;
  } else {
    return "";
  }
}

//Method used to load external script at component level
loadExternalScript(path:string) {
  let body = <HTMLDivElement> document.body;
  let script = document.createElement('script');
  script.innerHTML = '';
  script.src = path;
  script.async = true;
  script.defer = true;
  body.appendChild(script);
}

 //Method to check string ends with
 stringEndsWith(str: any, suffix: any) {
  return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

//Method to append escapse char at end
addEscapeChar(obj:any){
	var minContent = $(obj).html().trim();
	var spaceChar = "&nbsp;";
	var breakChar  = "<br>";
	var alterBreakChar  = "<div><br></div>";
	if(minContent!=undefined){
		var matchString = minContent.substring(minContent.length,minContent.length-breakChar.length);
		var matchAltString = minContent.substring(minContent.length,minContent.length-alterBreakChar.length);
		if(matchString!=breakChar && matchAltString!=alterBreakChar){
			matchString = minContent.substring(minContent.length,minContent.length-spaceChar.length);
			if(matchString!= spaceChar && ($(obj).hasClass("agendaTitleCls") && $(obj).find(".atwho-inserted").length>0)){
				$(obj).append(spaceChar);
			}
		}
		if(obj!=null && obj!=undefined){
			var elemId:any = $(obj).attr("id");
			var elem:any = document.getElementById(elemId)?.lastChild;
			if((elem?.nodeName.toUpperCase()=="SPAN")){
				if(elem?.getAttribute("contenteditable")=="false" || elem.getAttribute("contenteditable")==false){
						$(obj).append(spaceChar);
					  return true;
				}
			}
		}	
	}
  return true;
}

//Method to remove duplicate id attribute
  removeDuplicateIdFromDate(){
    $('.minDateCls').each(function(){
        var ids = $('[id="'+this.id+'"]');
        if(ids.length>1 && ids[0]==this){
          $('[id="' + this.id + '"]:gt(0)').remove();
        } else {
            $('[id="' + this.id + '"]').children('div:first').attr("style", "display: none");
        }
      });
  }
//To get the curDate based on the timezone without time
getCurDateWithoutTime(){
	var curSysDate = new Date();
 	var nowUtcDate = curSysDate.getTime() + (curSysDate.getTimezoneOffset() * 60000);//current utc date with time
 	var nowDate = new Date(nowUtcDate + (3600000*(this.globals.vTimeZoneIntOffset)));	
 	nowDate.setHours(0,0,0,0);
 	return nowDate;
}

//Method to check duplicate attendee section
checkduplicateModernAttendee(elem:any){
  var dup_facilitatorvalues="";   
  $(elem).each(function(){
      if($(this).attr("fkuserid")!=null && $(this).attr("fkuserid")!="" && $(this).attr("fkuserid")!="null"){
          dup_facilitatorvalues+=$(this).attr("fkuserid")+",";
      }
  });   
  return dup_facilitatorvalues;
}

getInitial(name:String){
	var finalChar = "";
  var firstchar:any = 0;
  var thirdchar:any = 0;
  var lastchar:any = 0;
  if (name != null && name!="" && name!="null") {
    var len = name.length - 1;
    if (name.charAt(1) == ' ' || name.charAt(1) == '.') {
      firstchar = name.charAt(0);
      thirdchar = name.charAt(2);
      finalChar = firstchar.toUpperCase() + thirdchar.toUpperCase();
    } else if (name.charAt(len - 1) == ' ') {
      firstchar = name.charAt(0);
      lastchar = name.charAt(len);
      finalChar = lastchar.toUpperCase() + firstchar.toUpperCase();
    } else if (name.charAt(len - 2) == ' ') {
      lastchar = name.charAt(len);
      firstchar = name.charAt(len - 1);
      finalChar = firstchar.toUpperCase() + lastchar.toUpperCase();
    } else if (name.charAt(1) != ' ') {
      firstchar = name.charAt(0);
      thirdchar = name.charAt(1);
      finalChar = firstchar.toUpperCase() + thirdchar.toUpperCase();
    } else if (name.charAt(len - 1) != ' ') {
      lastchar = name.charAt(len);
      firstchar = name.charAt(len - 1);
      finalChar = firstchar.toUpperCase() + lastchar.toUpperCase();
    }
  }
  return finalChar;
}

//Method to check duplicate attendee While editing
checkduplicateEditAttendee(elem:any){
  var dup_facilitatorvalues=""; 
  var currentUserId = this.nvl($("#editAttendeeDialog").find("#attUserId").val());
  $(elem).each(function(){
      if(($(this).attr("fkuserid")!=null && $(this).attr("fkuserid")!="" && $(this).attr("fkuserid")!="null") && ($(this).attr("fkuserid")!=currentUserId)){
        
          dup_facilitatorvalues+=$(this).attr("fkuserid")+",";
          
      }
  });  
  return dup_facilitatorvalues;
}

//Method to check duplicate in Task Edit
checkduplicateEditTaskAttendee(elem:any){
  var dup_facilitatorvalues=""; 
  var currentUserId = this.nvl($("#attUserId").find("#attUserId").val());
  
  
  $(elem).each(function(){
    
      if(($(this).attr("fkuserid")!=null && $(this).attr("fkuserid")!="" && $(this).attr("fkuserid")!="null") && ($(this).attr("fkuserid")!=currentUserId)){
          dup_facilitatorvalues = $(this).attr("fkuserid")+",";
          
      }
  });  
  return dup_facilitatorvalues;
}

//Method to set current system date 
curSysDate(dtformat:any){
	var curSysDate=new Date();
	var meetUtc = curSysDate.getTime() + (curSysDate.getTimezoneOffset() * 60000);//current utc date with time
	var fullDate = new Date(meetUtc + (3600000*(this.globals.vTimeZoneIntOffset)));
  return moment(fullDate).format("MMM DD, YYYY");
}

public get featureList(): typeof Features {
  return Features; 
}
public get permissionType(): typeof PermissionType {
  return PermissionType; 
}

 getCaretPosition(editableDiv:HTMLElement) {
  var caretPos = 0, sel, range;
  if (window.getSelection) {
    sel = window.getSelection();
    if (sel!=null && sel.rangeCount) {
      range = sel.getRangeAt(0);
      if (range.commonAncestorContainer.parentNode == editableDiv) {
        caretPos = range.endOffset;
      }
    }
  }
  
  return caretPos;
  }

  setCursor(pos:number,editorElem:HTMLElement) {
    
    var tag = editorElem;
      
    // Creates range object
    var setpos = document.createRange();
      
    // Creates object for selection
    var set = window.getSelection();
      
    // Set start position of range
    setpos.setStart(tag.childNodes[0], pos);
      
    // Collapse range within its boundary points
    // Returns boolean
    setpos.collapse(true);
      
    // Remove all ranges set
    if(set!=null)
    set.removeAllRanges();
      
    // Add range with respect to range object.
    if(set!=null)
    set.addRange(setpos);
      
    // Set cursor on focus
    tag.focus();
}

}
